import cookie from '../cookie'

export default class S3 {
  constructor(api) {
    this.api = api
  }

  uploadImage = async data => {
    const res = await this.api.post('/UploadToS3?app=DCS-NGN&folder=TVA', {
      data,
      headers: {
        'content-type': 'image/png',
        ...cookie.authorizationTokenHeader()
      },
      mock: 'uploadImage.json'
    })
    return res
  }
}
